import { useState } from "react";
import { ThumbsUp, ThumbsDown, Meh, Check } from "lucide-react";
import { toast } from "sonner";
import { sendFeedback } from "@/lib/api";
import { useLang } from "@/i18n";

const OPTIONS = [
  { value: "si", label: "Sì", icon: ThumbsUp },
  { value: "abbastanza", label: "Abbastanza", icon: Meh },
  { value: "no", label: "No", icon: ThumbsDown },
];

export const TripActions = ({ trip }) => {
  const { t } = useLang();
  const [feedback, setFeedback] = useState(trip.feedback);

  const rate = async (value) => {
    try {
      await sendFeedback(trip.id, value);
      setFeedback(value);
      toast.success(t("Grazie per il tuo feedback!"));
    } catch {
      toast.error(t("Impossibile salvare il feedback."));
    }
  };

  return (
    <div data-testid="mvp-actions-container" className="no-print rounded-3xl bg-gray-900 p-8 text-white md:p-10">
      <div data-testid="feedback-section">
        <p className="font-display text-xl font-semibold">{t("Questo itinerario ti è stato utile?")}</p>
        <div className="mt-4 flex flex-wrap gap-3">
          {OPTIONS.map(({ value, label, icon: Icon }) => {
            const active = feedback === value;
            return (
              <button key={value} data-testid={`feedback-${value}-button`} onClick={() => rate(value)} aria-pressed={active}
                className={`inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-semibold transition-[background-color,transform] active:scale-95 ${active ? "bg-emerald-500 text-white" : "bg-white/10 text-white hover:bg-white/20"}`}>
                {active ? <Check className="h-4 w-4" /> : <Icon className="h-4 w-4" />}{t(label)}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};
